var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.5C0 28.3203 0 26.2305 0.222762 24.4751C1.83042 11.8063 11.8063 1.83042 24.4751 0.222762C26.2305 0 28.3203 0 32.5 0C36.6797 0 38.7695 0 40.5249 0.222762C53.1937 1.83042 63.1696 11.8063 64.7772 24.4751C65 26.2305 65 28.3203 65 32.5V65H32.5C28.3203 65 26.2305 65 24.4751 64.7772C11.8063 63.1696 1.83042 53.1937 0.222762 40.5249C0 38.7695 0 36.6797 0 32.5Z",
    fill: "url(#paint0_linear_1_216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1252 15.3499C22.8236 15.3499 15.3589 23.7543 15.3589 33.0807C15.3589 36.0595 16.2277 39.1269 17.7525 41.9284C18.0362 42.3894 18.0717 42.9745 17.8767 43.5242L16.6887 47.4959C16.4227 48.4534 17.2384 49.1626 18.1426 48.8789L21.7243 47.8151C22.6994 47.4959 23.4619 47.9037 24.3679 48.4534C26.9566 49.9782 30.1819 50.7584 33.0897 50.7584C41.8842 50.7584 50.8205 43.9675 50.8205 33.0275C50.8205 23.5947 43.1963 15.3499 33.1252 15.3499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8824 35.3707C23.6415 35.3707 22.6133 34.3425 22.6133 33.1016C22.6133 31.843 23.6237 30.8325 24.8824 30.8325C26.141 30.8325 27.1515 31.843 27.1515 33.1016C27.1515 34.3425 26.141 35.353 24.8824 35.3707ZM33.0582 35.3709C31.7995 35.3532 30.7891 34.3427 30.7891 33.0841C30.7891 31.8432 31.8172 30.815 33.0582 30.8327C34.3168 30.8327 35.3272 31.8432 35.3272 33.1018C35.3272 34.3427 34.3168 35.3709 33.0582 35.3709ZM38.9606 33.1016C38.9606 34.3425 39.9711 35.3707 41.2297 35.3707C42.4883 35.3707 43.4988 34.3425 43.4988 33.1016C43.4988 31.843 42.4883 30.8325 41.2297 30.8325C39.9711 30.8325 38.9606 31.843 38.9606 33.1016Z",
    fill: "url(#paint1_linear_1_216)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_216",
    x1: 65,
    y1: 7.8,
    x2: -1.54871,
    y2: 9.95174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_216",
    x1: 43.4988,
    y1: 31.3771,
    x2: 22.557,
    y2: 34.4932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5DC0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.6263199e2f01bef79fc8ca7bf2f90239.svg";
export { ForwardRef as ReactComponent };